// src/components/common/PageTitle.js
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const PageTitle = () => {
  const location = useLocation();
  
  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;

    // Special cases with dynamic routes
    if (path.match(/^\/clients\/\d+$/)) return "Kundendetails";
    if (path.match(/^\/employees\/\d+$/)) return "Mitarbeiterdetails";
    if (path.match(/^\/profile/)) return "Profil";
    if (path.match(/^\/reports\/\d+$/)) return "Terminbericht";
    if (path.match(/^\/submit-report\/\d+$/)) return "Terminbericht erstellen";

    // Standard paths
    const pathMap = {
      '/': 'Home',
      '/calendar': 'Kalender',
      '/notifications': 'Mitteilungen',
      '/emails': 'E-Mails',
      '/clients': 'Kunden',
      '/admin': 'Administrationsbereich',
      '/dashboard': 'Dashboard',
      '/login': 'Anmelden',
      '/setup': 'Ersteinrichtung',
      '/office': 'Büro Dashboard',
      '/reports': 'Terminberichte',
      '/time-off': 'Urlaub & Abwesenheit',
      '/invoices': 'Rechnungen',
      '/work-hours': 'Arbeitszeiten',
    };

    return pathMap[path] || 'Dolmio';
  };

  const pageTitle = getPageTitle();

  return (
    <Helmet>
      <title>{pageTitle} | Dolmio</title>
      <meta name="description" content="Terminverwaltung für Gebärdensprachdolmetscher" />
    </Helmet>
  );
};

export default PageTitle;